import { ApiClient } from "./client";
import { FetchError } from "./fetch-error";
export const AUTH_API_ENDPOINTS_BY_ENV = {
    mainnet: "https://api.mezo.org",
    testnet: "https://api.test.mezo.org",
};
export class AuthApiClient extends ApiClient {
    constructor(environment = "mainnet", apiUrl) {
        super({
            apiUrl: apiUrl ?? AUTH_API_ENDPOINTS_BY_ENV[environment],
        });
    }
    async getSession(code) {
        const data = await this.handleRequest("/session", {
            method: "GET",
            queryParams: { code },
        });
        return data;
    }
    async createSession(createSessionRequest) {
        const data = await this.handleRequest("/session", {
            method: "POST",
            body: createSessionRequest,
        });
        return data;
    }
    async deleteSession() {
        const data = await this.handleRequest("/session", {
            method: "DELETE",
        });
        return data;
    }
    async getCurrentAccount() {
        const data = await this.handleRequest("/session/account", {
            method: "GET",
        });
        return data;
    }
    async getAccountByMezoIdOrAddress(mezoIdOrAddress) {
        let data;
        try {
            data = await this.handleRequest(`/accounts/${mezoIdOrAddress}`, {
                method: "GET",
            });
        }
        catch (error) {
            // Return null if account is not found instead of throwing an error
            if (error instanceof FetchError && error.status === 404) {
                data = null;
            }
            else {
                throw error;
            }
        }
        return data;
    }
    async linkAccount(linkAccountRequest) {
        const data = await this.handleRequest("/session/account/linked-accounts", {
            method: "POST",
            body: linkAccountRequest,
        });
        return data;
    }
    async createAccount(createAccountRequest) {
        const data = await this.handleRequest("/accounts", {
            method: "POST",
            body: createAccountRequest,
        });
        return data;
    }
    async updateMezoId(newMezoId) {
        const data = await this.handleRequest("/session/account", {
            method: "PATCH",
            body: { mezoId: newMezoId },
        });
        return data;
    }
}
//# sourceMappingURL=auth.js.map